import React from 'react'
import DeniReactTreeView from 'deni-react-treeview';
import './styleCalender.css';
import { Col, Row, Input } from 'reactstrap';


export const CaptureAmount = (props) => {

    const { handleChangeAmount, treeViewRef, listBranchesTree, onRenderItem, onChangeItemtree } = props;


    return (
        <div className='pt-3' >
            <div
                style={{
                    color: "#856404",
                    fontSize: "0.78rem",
                    marginTop: "6px",
                    fontWeight: "500",
                    backgroundColor: "#fff3cd",
                    padding: "4px 10px",
                    borderRadius: "6px",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    border: "1px solid #ffeeba",
                }}

            >
                <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                Para programar un monto es necesario al menos seleccionar una sucursal y un monto minimo de $1.
            </div>

            <Col sm="12" className='pt-3 p-l-0 p-r-0' >
                {
                    <div className=''>
                        <Row>
                            <Col sm="4">
                                <label className='f-w-600 ' style={{ color: "#002940", fontSize: "13px" }}>Sucursales *</label>
                                <DeniReactTreeView
                                    items={listBranchesTree}
                                    ref={treeViewRef}
                                    showCheckbox={true}
                                    showIcon={false}
                                    onRenderItem={onRenderItem}
                                    style={{ marginRight: '10px', marginBottom: '10px', height: '240px', border: 'none' }}
                                    onCheckItem={(e) => onChangeItemtree(e)}
                                    className="deni-react-treeview-container-4"
                                />
                            </Col>
                            <Col sm="1">
                            </Col>
                            <Col sm="2">
                                <label className='f-w-600 ' style={{ color: "#002940", fontSize: "13px" }}>Monto *</label>
                                {listBranchesTree?.map((_find, _key) => (
                                    _find.children.map((_branch) => {
                                        return (
                                            <div key={_branch.id} className={`p-1 `}>
                                                <Input type='text' name="amount" value={_branch.amount} onChange={(e) => handleChangeAmount(e, _branch.id)} autoComplete='off'
                                                    className={`form-control form-control-sm input-air-${_branch.color} ${_branch?.state == 2 ? 'd-none' : ''}`} />
                                            </div>
                                        );
                                    })
                                ))}
                            </Col>
                        </Row>
                    </div>
                }
            </Col>
        </div>
    )

}
